var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "g-display-list-filtering__item g-display-list-filtering__sort-by",
    },
    [
      _vm.sorting
        ? _c("ul", { staticClass: "g-form-list" }, [
            _c("li", { staticClass: "g-form-list__item" }, [
              _c(
                "label",
                {
                  staticClass: "g-form-label",
                  attrs: { for: "sort-by" + _vm.labelUid },
                },
                [
                  _vm._v("Sort By"),
                  _c("span", {
                    staticClass:
                      "g-display-list-filtering__sort-by-icon u-icon-chevron-down",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "g-form-select" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.sortBy,
                        expression: "sortBy",
                      },
                    ],
                    staticClass: "g-form-select__dropdown-display",
                    attrs: { id: "sort-by" + _vm.labelUid },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.sortBy = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.sorting.options, function (option) {
                    return _c(
                      "option",
                      { key: option.label, domProps: { value: option.label } },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(option.label) +
                            "\n\t\t\t\t\t"
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "g-display-list-filtering__sort-by-option" },
                [_vm._v("\n\t\t\t\t" + _vm._s(_vm.sortBy) + "\n\t\t\t")]
              ),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }